import { useEffect } from "react";
import { useParams } from "react-router-dom";
import OssFascicoli from "../oss/OssFascicoli";
import OssFascicoloDettaglio from "../oss/OssFascicoloDettaglio";
import { SANITARIO_OSPITE_KEY } from "../../context/SanitarioAuthContext";

/** Elenco ospiti o scheda clinica (riuso area OSS, API cliniche condivise). */
export default function SanitarioScheda() {
  const { id } = useParams();

  useEffect(() => {
    if (id) localStorage.setItem(SANITARIO_OSPITE_KEY, id);
  }, [id]);

  if (id) return <OssFascicoloDettaglio />;
  return <OssFascicoli />;
}
